import React, { useEffect, useState } from 'react';
import { createGlobalStyle, CSSObject } from 'styled-components';
import { useCustomComponentStateContext } from '../hooks/useCustomComponentState';

function GlobalStyleTag() {
  const { state } = useCustomComponentStateContext();
  const { globalScopeCSS } = state?.queryData?.retailerSettings || {};

  const [globalStyles, setGlobalStyles] = useState<JSX.Element>();

  useEffect(() => {
    setGlobalStyles(
      <>
        {(Array.isArray(globalScopeCSS) ? globalScopeCSS : []).map(
          (globalStyle: CSSObject, index: number) => {
            const GlobalStyle = createGlobalStyle(globalStyle);
            return <GlobalStyle key={index} />;
          },
        )}
      </>,
    );
  }, [globalScopeCSS]);

  return globalStyles ?? <></>;
}

export default GlobalStyleTag;
